module.exports = __webpack_public_path__ + "static/media/volunteer.3f7b68a3.png";